module.exports = __webpack_public_path__ + "static/media/felix.969e9e03.jpeg";